'use strict';

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import PropTypes from 'prop-types';
import React, { PureComponent, Component } from 'react';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Input from '@material-ui/core/Input';
import NativeSelect from '@material-ui/core/NativeSelect';
let app = window.app;
class WrappedSelect extends PureComponent {
  componentDidMount() {
    const component = this,
      props = this.props;
    if (typeof props.value !== 'undefined') return;
    props.onChange({
      e: null,
      value: props['default-value'] || '',
      name: props.name,
      source: 'DidMount'
    });
  }
  handleChange = e => {
    const component = this,
      props = this.props;
    let value = e.target.value;
    props.onChange({
      e: e,
      value: value,
      name: props.name,
      source: 'native'
    });
  };
  render() {
    const component = this,
      props = this.props;
    let error_msg,
      status = props.status[props.name] || {};
    let class_name = props.className;
    const id = props.id || String(++app.form_index);
    if (props['full-width']) {
      class_name += (class_name ? ' ' : '') + 'u-full-width';
    }
    class_name += ' mui-select';
    if (status && status.error) {
      error_msg = /*#__PURE__*/React.createElement(FormHelperText, null, status.error);
    }
    const options = props.getOptions().map(function (option, key) {
      let output = /*#__PURE__*/React.createElement("option", {
        value: option.value,
        key: key
      }, option.label || option.value || '');
      return output;
    });
    let styles = {
      ...props.style
    };
    if (props['no-margin']) {
      styles = {
        formControl: {
          marginTop: 0
        }
      };
    }
    const no_value_option = props['no-value-option'] ? /*#__PURE__*/React.createElement("option", {
      value: "",
      style: {
        display: 'none'
      }
    }) : undefined;
    const label = props.label ? /*#__PURE__*/React.createElement(InputLabel, {
      htmlFor: id
    }, props.label) : undefined;
    const value = typeof props.value === 'undefined' ? props['default-value'] : props.value;
    let output = /*#__PURE__*/React.createElement("div", {
      className: class_name,
      style: props.style
    }, /*#__PURE__*/React.createElement(FormControl, {
      fullWidth: props['full-width'],
      error: Boolean(status.error),
      style: styles
    }, label, /*#__PURE__*/React.createElement(NativeSelect, {
      id: id,
      onChange: component.handleChange,
      value: value,
      name: props.name,
      required: props.required,
      input: /*#__PURE__*/React.createElement(Input, null),
      disabled: props['read-only'] === true
    }, no_value_option, options), error_msg));
    return output;
  }
}
WrappedSelect.propTypes = {
  'no-value-option': PropTypes.bool,
  'full-width': PropTypes.bool,
  'no-margin': PropTypes.bool,
  required: PropTypes.bool,
  className: PropTypes.string,
  label: PropTypes.string,
  name: PropTypes.string.isRequired,
  'default-value': PropTypes.string,
  value: PropTypes.string,
  status: PropTypes.object.isRequired,
  style: PropTypes.object,
  onChange: PropTypes.func.isRequired
};
WrappedSelect.defaultProps = {
  'no-value-option': true,
  'full-width': true,
  'no-margin': false,
  required: false,
  'default-value': '',
  className: '',
  style: {}
};
export default class SelectStore extends Component {
  retrieveOptions = () => {
    return this.options;
  };
  render() {
    this.options = this.props.options;
    return /*#__PURE__*/React.createElement(WrappedSelect, _extends({}, this.props, {
      options: undefined,
      getOptions: this.retrieveOptions
    }));
  }
}
SelectStore.propTypes = {
  options: PropTypes.array.isRequired
};
